// extracted by mini-css-extract-plugin
export default {"slider":"f7uMR","slider-adoptables":"_3D_8Z","sliderAdoptables":"_3D_8Z","slider-item":"_1-eY1","sliderItem":"_1-eY1"};